import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f6ee02a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blue" }
const _hoisted_2 = {
  class: "template",
  id: "clientwork"
}
const _hoisted_3 = ["data-aos"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardtitle" }, "Facility Management", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardsubtitle" }, "iOS & Android Mobile App", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carddescription" }, "An app built for a client designed for their own payroll management, inventory management, and replenishing system.", -1))
const _hoisted_9 = { class: "flex-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_11 = { class: "card" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardtitle" }, "Ephemerafinds.com", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardsubtitle" }, "Shopify Website", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carddescription" }, "Slightly out of my normal scope, a shopify website built for a client, that allows customers to view, barder, bid, and order antiques", -1))
const _hoisted_15 = { class: "flex-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_17 = { class: "card" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardtitle" }, "EcoSquirrel", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardsubtitle" }, "iOS & Android Mobile App", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carddescription" }, "An app built for a client designed to give anyone the ability to contribute to saving the environment. When user shops at an ecofriendly company like Target, Bestbuy, Walmart, etc, the user recieves X amount of eco points which can later be redeemed as donations to community built environmental projects.", -1))
const _hoisted_21 = { class: "flex-row flex-wrap" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_23 = { class: "card" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardtitle" }, "Apartment Finder", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "cardsubtitle" }, "API", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "carddescription" }, "A backend built for a client that would allow their users to be the first to know when an apartment became available via text and email", -1))
const _hoisted_27 = { class: "flex-row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))

import { useLanguageSwitcher } from '@/composables/useLanguageSwitcher';
import { FadeDown, FadeLeft, FadeRight } from '@/constants/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultingProjects',
  setup(__props) {

const { t } = useLanguageSwitcher();


return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        "data-aos": _unref(FadeDown),
        class: "title"
      }, _toDisplayString(_unref(t)('projects.title')), 9, _hoisted_3),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Vue3")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Typescript")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Ionic")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Firebase")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Shopify")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Custom CSS")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("3rd Party Apps")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _hoisted_19,
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Xamarin")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("C#")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("AWS LLambda")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Firebase")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Plaid SDK")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("MVVM")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _hoisted_25,
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("C#")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Docker")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, { class: "chip" }, {
            default: _withCtx(() => [
              _createTextVNode("Twilio SDK")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_28
    ])
  ]))
}
}

})